<template>
  <div
    class="CustomerConsumption"
    v-loading="loading"
  >
    <div class="Dashboard-title">消费视图
      <div
        class="CustomerConsumptionChart-tip"
        style="color:#333;font-size:14px;text-align: center;"
      >
        消费总金额：<span
          class="CustomerConsumption-total"
          style="color:#f00;"
        >0.00元</span>
        消费笔数：<span
          class="CustomerConsumption-count"
          style="color:#f00;"
        >0笔</span>
      </div>
    </div>
    <Chart
      :data="consumeList"
      :consumeCount="consumeCount"
    />
  </div>
</template>

<script>
import Chart from './chart';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CustomerConsumption',
  components: {
    Chart,
  },
  computed: {
    ...mapGetters('Dashboard/customerData/customerConsumption', [
      'consumeList',
      'consumeCount',
      'loading',
    ]),
  },
  created() {
    this.initData();
  },
  methods: {
    ...mapActions('Dashboard/customerData/customerConsumption', [
      'getConsumeOrderList',
    ]),
    initData() {
      this.getConsumeOrderList();
    },
  },
};
</script>

<style lang="scss">
.CustomerConsumption {
  .Dashboard-title {
    display: flex;
    align-items: center;
  }
  .CustomerConsumptionChart-tip {
    position: absolute;
    right: 0;
    margin-left: 10px;
    color: #333;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
  }
}
</style>

